/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getSuggestedFollowsByActor.defs'
export { main as default } from './getSuggestedFollowsByActor.defs'
